import SamplePageContainer from "../../components/pages/samplePage";

const SamplePage = () => {
  return <SamplePageContainer />;
};

export default SamplePage;
